module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// LiveshowChecker Widget

(function (fox, $) {
	'use strict';
	
	fox.registerWidget('LiveshowChecker', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					api1: {
						widget: 'Api',
						method: 'Liveshow.getStarted',
						sendTimezone: true,
						handleWom: {
							success: {
								event: ['success', 'error', 'failure'],
								widget: '@this',
								callback: '@parent:apiSuccess'
							}
						}
					},
					api2: {
						widget: 'Api',
						method: 'content.load',
						cacheChannel: 'content',
						sendTimezone: true,
						handleWom: {
							success: {
								event: ['success', 'error', 'failure'],
								widget: '@this',
								callback: '@parent:apiSuccess'
							}
						}
					}
				},
				handleWom: {
					liveshowModelConnected: {
						event: 'inboxSocketEventLiveshow:connect',
						widget: '@root #socket',
						callback: 'checkLiveshowGetStarted'
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this.api1Status = false;
			this.api2Status = false;

			this.embedMenuLink();
		
			this.callParent('init', arguments);
		},

		running: function () {
			this.ml = this.rwom1('#menuLink');
			this.ml._readyToRender = false;

			this.checkLiveshowGetStarted();
		
			this.callParent('running', arguments);
		},

		activate: function () {
			this.renderMenuLink();
			
			this.callParent('activate', arguments);
		},

		embedMenuLink: function () {
			this.ml = this.embedWidget('menuLink', 'Widget', fox.merge({
				autoRender: false,
				'embed.location': 'under'
			}, this.getOption('menuLink')));

			return this;
		},

		checkLiveshowGetStarted: function () {
			var api;

			this.api1Status = false;

			if ((api = this.wom1('#api1'))) {
				api.send();
			}
		},

		checkLiveshowRecorded: function () {
			var api;

			this.api2Status = false;

			if ((api = this.wom1('#api2'))) {
				api.send({
					transitParameters: {preset: 'recordedLiveshows'}
				});
			}
		},

		apiSuccess: function (res, p, eventName) {
			if (fox.inArray(['error', 'failure'], eventName)) {
				res = res.answer;
			} else {
				res = res.answer.response;
			}

			switch (p.getAlias()) {
				case 'api1': 
					if (res.success &&
						fox.inArray(['inited', 'next_liveshow'], res.success.status) ||
						res.id && res.sign) {
						this.api1Status = true;
					} else {
						this.checkLiveshowRecorded();
					}

					break;
				case 'api2':
					this.api2Status = fox.objectGet(res, 'isExists');
					break;
			}

			this.renderMenuLink();
		},

		isLiveshowAvailable: function () {
			return (this.api1Status || this.api2Status) && !this.ml.isEmbedded();
		},

		renderMenuLink: function () {
			if (this.isLiveshowAvailable() === true) {
				this.ml.render();
			}
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/liveShowChecker.js
// module id = 878
// module chunks = 4